// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import onePageCheckoutAddressSectionSharedStyles from "@bg/App/SharedStyles/OnePageCheckout/OnePageCheckoutAddressSectionSharedStyles";
import { onePageCheckoutShippingAddressStyles } from "@bg/App/Widgets/OnePageCheckout/OnePageCheckoutShippingAddress";
import color from "@bg/XDL/Utilities/color";
import { css } from "styled-components";

onePageCheckoutShippingAddressStyles.container = {
    ...onePageCheckoutAddressSectionSharedStyles.container,
};

onePageCheckoutShippingAddressStyles.titleContainer = {
    ...onePageCheckoutAddressSectionSharedStyles.titleContainer,
};

onePageCheckoutShippingAddressStyles.heading = {
    ...onePageCheckoutAddressSectionSharedStyles.heading,
};

onePageCheckoutShippingAddressStyles.addressSection = {
    css: css`
        margin-top: 14px;
    `,
};

onePageCheckoutShippingAddressStyles.selectorRadioGroup = {
    labelProps: {
        css: css`
            display: none;
        `,
    },
    css: css`
        margin-top: 2px;
    `,
};

onePageCheckoutShippingAddressStyles.divider = {
    css: css`
        margin: 15px 0;
        height: 1px;
        width: 100%;
        background: ${color("common.ui3")};
    `,
};

onePageCheckoutShippingAddressStyles.editSavedAddressLink = {
    typographyProps: {
        size: 15,
        weight: 500,
        lineHeight: "25px",
    },
    css: css`
        line-height: 25px;
        margin-top: 16px;
    `,
};
